import { ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants } from '@festina/moneyin-general-types/moneyin/hooks/ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants'

export const useFetchMoneyInTenants =
  ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants.useSuspenseQuery
